export const DirectoryResource = {
    filter_lbl: "Filters",
    reset_lbl: "Reset",
    location_lbl: "Location",
    map_lbl: "Map Location",
    name_lbl: "Last Name",
    contact_lbl: "Contact Information",
    city_lbl: "City",
    state_lbl: "State",
    country_lbl: "Country",
    zip_lbl: "Zip code",
    phone_lbl: "Phone",
    pediatrician_lbl: "Member",
    boards_lbl: "Board Certifications",
    specialty_lbl: "Medical Specialty",
    sub_specialty_lbl: "Subspecialty",
    interest_lbl: "Interest",
    education_lbl: "Education & Training",
    gradYear_lbl: "Medical School Grad Date",
    languages_lbl: "Languages Spoken",
    gender_lbl: "Gender",
    website_lbl: "Website",
    terms_lbl: "Terms & Conditions",
    accept_btn: "Accept & Continue",
    agree_prefix: "This tool requires that you agree to the Member Directory ",
    agree_link_text: "terms & conditions",
    agree_suffix: ".",
    no_results_lbl: "No results match your criteria.",
    terms_link: "https://www.aap.org/en/pages/terms-of-use/",
    error_title: "Error",
    error_message: "Sorry, we've hit a snag. Please try again later.",
    instruction_text_hdr: "<h3>How to use this tool</h3>",
    instruction_bullet_1: "Use the filters to search for members in the AAP Member Directory.",
    instruction_bullet_2: "Click on a member's name for more detail.",
    instruction_bullet_3: "Click Reset to clear all filters.",
    instruction_bullet_4: "If your data is not showing up correctly, you may need to edit the information on your <a href='http://www.aap.org/en/my-account' target='_blank'>MyAccount</a> page, including adding/removing access to member directory in some cases.",
};